import api from "./api";

export default {

    async list(options = {}) {
        return api.usuarioSemPermissao('pdi_visualizar') ? false : api.get('/pdi', { params: options });
    },
    async insert(form) {
        return api.usuarioSemPermissao('pdi_inserir') ? false : api.post('/pdi', form);
    },
    async get(id){
        return api.usuarioSemPermissao('pdi_visualizar') ? false : api.get(`/pdi/${id}`)
    },
    async update(form, id){
        return api.usuarioSemPermissao('pdi_editar') ? false : api.put(`/pdi/${id}`, form)
    },
    async delete(id) {
        return api.usuarioSemPermissao('pdi_excluir') ? false : api.delete(`/pdi/${id}`);
    },


    async checkPdiPendente(){
        return api.get(`/pdiuser/checkPendentes`);
    },

    async listItems() {
        return api.get('/pdi_itens');
    },
    async createItem(item) {
        return api.post('/pdi_itens', item);
    },
    async updateItem(item, id) {
        return api.put(`/pdi_itens/${id}`, item);
    },

    async getConfiguracao(id) {
        return api.get(`/pdi_configuracao/${id}`);
    },
    async updateConfiguracao(configuracao) {
        return api.put('/pdi_configuracao', configuracao);
    },
    async setConfiguracao(configuracao) {
        return api.post('/pdi_configuracao', configuracao);
    },
    async getUsuarios() {
        return api.get('/pdi_configuracao/usuarios');
    },

    // Métodos para respostas do PDI
    async getDue() {
        return api.get('/pdi_responses/due');
    },
    async storeMany(payload) {
        return api.post('/pdi_responses/bulk', payload);
    },

}
